import React from 'react';
import { Typography, Chip } from '@mui/material';

/**
 * Status colors mapping
 */
const statusColors: Record<string, { backgroundColor: string; color: string }> = {
  Held: { backgroundColor: '#fee2e2', color: '#dc2626' },
  InApproval: { backgroundColor: '#fef3c7', color: '#d97706' },
  Payable: { backgroundColor: '#dcfce7', color: '#16a34a' },
  Postable: { backgroundColor: '#dbeafe', color: '#2563eb' },
  Rejected: { backgroundColor: '#fce7f3', color: '#be185d' },
  Started: { backgroundColor: '#f3f4f6', color: '#374151' },
};

/**
 * Refund status chip template
 */
export const RefundStatusChipTemplate: React.FC<{ status?: string }> = ({ status }) => {
  if (!status) {
    return (
      <Typography variant="body2" sx={{ color: '#94a3b8' }}>
        -
      </Typography>
    );
  }

  const statusColor = statusColors[status] || { backgroundColor: '#f3f4f6', color: '#374151' };

  return <Chip label={status} size="small" sx={statusColor} />;
};

export default RefundStatusChipTemplate;
